module.exports = __webpack_public_path__ + "static/img/35.7e9e390a.gif";